import cn from 'classnames';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';

import classes from './link.module.scss';

interface ILinkProps {
  title: string;
  route: string;
  typeColor: 'black' | 'white';
  isNavLink: boolean;
  isFooterLink?: boolean;
  isActive?: boolean;
  params?: {
    search: string;
  };
  onClick?: () => void;
}

function Link({
  title,
  route,
  typeColor,
  isNavLink,
  isFooterLink,
  isActive,
  params,
  onClick,
}: ILinkProps) {
  return isNavLink ? (
    <NavLink
      className={cn(classes[`link-${typeColor}`], {
        [classes.activeLink]: isActive,
        [classes.footerLink]: isFooterLink,
      })}
      to={{ pathname: route, ...params }}
      onClick={onClick}
    >
      {title}
    </NavLink>
  ) : (
    <a
      onClick={onClick}
      href={route}
      className={cn(classes[`link-${typeColor}`], {
        [classes.activeLink]: isActive,
        [classes.footerLink]: isFooterLink,
      })}
      target="blank"
    >
      {title}
    </a>
  );
}

export default memo(Link);
